'use strict';

const gtm = require('./modules/google').tagManager;

/**
 *
 * @param {element} productTile The clicked product tile
 */
function pushProductToDataLayer(productTile) {
    const productData = getProductDataFromProductTile(productTile);
    if (productData) {
        gtm.pushProductTileClick(productData);
    }
}

function getProductDataFromProductTile(productTile) {
    const productDataElement = $('.js-product-tile-datalayer-product', productTile);

    if (!productDataElement.length) {
        return null;
    }

    const productData = JSON.parse(productDataElement.val());
    return productData;
}

function init() {
    //Push product to data layer when (clickable) product tile is clicked
    $(document).on('click.datalayer', '.js-product-tile.js-linked-block', function(){
        pushProductToDataLayer($(this));
    });

    //Push product to data layer when 'view full details' link or the clickable image are clicked
    $(document).on('click.datalayer', '.js-view-full-details-link, .js-product-tile-image' , function(){
        const productTile = $(this).closest('.js-product-tile');

        if (productTile.hasClass('js-linked-block')) { //Don't do anything if the tile itself is clickable
            return;
        }

        pushProductToDataLayer(productTile);
    });

    if ($('.js-personalised-promo-block-anchor').length) {
        $('html, body').stop().animate({
            scrollTop: $('.js-product-list-slider-block').offset().top
        }, 1600, 'easeOutQuart');
    }
}

module.exports = {
    init: init
};
